import React from "react";

import "./Footer.css";

const Footer = () => {
  return (
    <div className="footer-parent-div">
      <p>Social Media App, SDE Bootcamp - HyperVerge</p>
    </div>
  );
};

export default Footer;
